import React from "react";
import { MainLeftTitle } from '../../../_uiComponents/WrapperComponents'
import Permissions from "./Permissions";

export const PermissionsWrapper = () => {
    return (
        <>       
            <div className='sbt-data-grid__wr'>
                <MainLeftTitle title="System Permissions">
                </MainLeftTitle>                
                <Permissions />
            </div>
        </>
    )

}